import type { SVGProps } from "react";
const SvgIconMonitorStroke = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M871 256H153c-13.81 0-25 11.19-25 25v426c0 13.81 11.19 25 25 25h284v50h-75c-13.81 0-25 11.19-25 25s11.19 25 25 25h300c13.81 0 25-11.19 25-25s-11.19-25-25-25h-75v-50h284c13.81 0 25-11.19 25-25V281c0-13.81-11.19-25-25-25m-25 426H178V306h668z" />
  </svg>
);
export default SvgIconMonitorStroke;
